import Auth from "./Auth";

export default function Login() {
  return (
    <Auth
      mode="signin"
      title="Login - MeetHub"
      description="Sign in to MeetHub to manage meetings, recordings, and team collaboration."
      canonicalPath="/login"
    />
  );
}
